import React, { useCallback, useRef, useState, useEffect, useContext } from 'react'
import { Button } from 'stories/Button'
import pig from '../icons/pig.svg'
import cedula from './KYC-cedula.svg'
import selfie from './KYC-selfie-phone.svg'
import { useNavigate } from 'react-router-dom'
import { KycContext } from '../Layout'

const KycIntro = () => {
  const carouselRef = useRef(null)
  const navParentRef = useRef(null)
  const navigate = useNavigate()
  const [activeSlide, setActiveSlide] = useState(0)
  const { kyc } = useContext(KycContext)

  const slides = [
    {
      image: pig,
      title: 'Todos tus datos son confidenciales',
      description: 'Te haremos algunas preguntas personales y financieras que nos exige la Ley.',
    },
    {
      image: cedula,
      title: 'Escanea tu documento de identidad',
      description:
        'Tendrás que usar la cámara de tu celular para encuadrar tu documento y escanearlo.',
    },
    {
      image: selfie,
      title: 'Confirma tu identidad con tu rostro',
      description: 'Toma una fotografía de tu rostro para terminar de verificar tu cuenta.',
    },
  ]

  // These functions are used to get the current slide on javascript and change the slide on the carousel
  const scrollToSlide = useCallback(index => {
    if (carouselRef.current) {
      const slideWidth = carouselRef.current.clientWidth
      carouselRef.current.scrollTo({
        left: index * slideWidth,
        behavior: 'smooth',
      })
      setActiveSlide(index)
    }
  }, [])

  const handleScroll = useCallback(() => {
    if (carouselRef.current) {
      const scrollLeft = carouselRef.current.scrollLeft
      const slideWidth = carouselRef.current.clientWidth
      const currentSlideIndex = Math.round(scrollLeft / slideWidth)

      setActiveSlide(currentSlideIndex)
    }
  }, [])

  const getPath = complianceType => {
    if (complianceType === 'TOC') {
      return 'toc/front'
    } else if (complianceType.includes('Manual')) {
      return 'manual-verification'
    } else {
      return 'toc/front'
    }
  }

  useEffect(() => {
    const carousel = carouselRef.current
    if (carousel) {
      carousel.addEventListener('scroll', handleScroll)
      return () => {
        carousel.removeEventListener('scroll', handleScroll)
      }
    }
  }, [handleScroll])

  return (
    <div className="block pb-12 px-2 w-full">
      <div className="max-w-[433px] h-[280px] mx-auto mb-7 text-center relative overflow-hidden">
        <div
          ref={carouselRef}
          id="carouselSlides"
          className="absolute flex overflow-x-scroll scroll-smooth snap-x snap-mandatory no-scrollbar"
          style={{
            scrollSnapType: 'x mandatory',
            WebkitOverflowScrolling: 'touch',
          }}>
          {slides.map(slide => (
            <div
              key={slide.id}
              id={slide.id}
              className="flex-shrink-0 w-full snap-center flex flex-col items-center pb-9"
              style={{ width: '100%' }}>
              <img
                src={slide.image}
                alt={slide.title}
                className="max-w-full max-h-[160px] object-contain"
              />
              <h1 className="text-2xl font-medium leading-8 tracking-[0.2px] my-4 text-center">
                {slide.title}
              </h1>
              <p className="text-lg font-normal leading-6 text-center min-h-[72px] px-4">
                {slide.description}
              </p>
            </div>
          ))}
        </div>
      </div>

      <div ref={navParentRef} className="flex justify-center space-x-5 w-24 mx-auto">
        {slides.map((slide, index) => (
          <button
            key={slide.id}
            onClick={() => scrollToSlide(index)}
            className={`h-3 w-3 rounded-full ${
              activeSlide === index ? 'bg-[#151ebd]' : 'bg-[#b6b9f7]'
            }`}>
            <span className="sr-only">Go to slide {index + 1}</span>
          </button>
        ))}
      </div>

      <div className="mt-40 items-center flex flex-col">
        <Button
          primary
          onClick={() => {
            const { documentType, countryCode, complianceType } = kyc
            const navigatePath =
              documentType && countryCode ? getPath(complianceType) : 'required-information'
            navigate(navigatePath)
          }}
          className="self-center lg:px-16 lg:py-4 lg:w-auto"
          size="full">
          Comenzar
        </Button>
        <div className="p-4 mt-4 rounded-lg text-red-600 text-sm">
          Recomendamos realizar el proceso de verificación desde un celular
        </div>
      </div>
    </div>
  )
}

export default KycIntro
